import { render } from "./videoAndTextTemplate.vue?vue&type=template&id=0880a6ee&scoped=true"
import script from "./videoAndTextTemplate.vue?vue&type=script&lang=js"
export * from "./videoAndTextTemplate.vue?vue&type=script&lang=js"

import "./videoAndTextTemplate.vue?vue&type=style&index=0&id=0880a6ee&lang=scss"
import "./videoAndTextTemplate.vue?vue&type=style&index=1&id=0880a6ee&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0880a6ee"]])

export default __exports__